import { normalize } from 'normalizr'
import { arrayOfAvailableCategories } from '../schemas/availableCategoriesSchema'

export default availableCategories => normalize(availableCategories, arrayOfAvailableCategories)



// WEBPACK FOOTER //
// ./adapters/parsers/availableCategoriesParser.js